module.exports = __webpack_public_path__ + "img/banner.21416f51.svg";